import {
  EagleMigrationStateRedirect,
  EagleRegisterLink,
  EagleAndroidAppLink,
  EagleIOSAppLink,
  Channel,
  Topic
} from "../constants";
import { MessageBrokerUtils } from "./messageBrokerUtils";
import { PageContextUtils } from "./pageContextUtils";
import { NavigationUtils } from "../utils";

export class MigrationUtils {
  static handleOpenRegistration = () => {
    MigrationUtils.register();
    return;
  };

  static register = () => {
    MessageBrokerUtils.publish({
      channel: Channel.PLAYER,
      topic: Topic.registerCompletion,
      headers: {
        publisher: "Registration"
      }
    });
  };

  static openNativeRegistrationLink = isIOS => {
    const link = isIOS ? EagleIOSAppLink : EagleAndroidAppLink;
    NavigationUtils.openExternalUrl(link);
  };

  static openWebRegistrationLink = () => {
    window.location.href = EagleRegisterLink;
    return;
  };

  static isSportRoMigrationOngoing = () => {
    var { configuration } = PageContextUtils.getMigrationData();

    if (configuration.stateId >= EagleMigrationStateRedirect) return true;
    return false;
  };
}
